import { AccessLevelEnum } from 'src/utils/config/config'
import { accessLevelStepOptions, franchiseGroupStepFunction, inviteTeammate, locationStepFunction } from './actions/inviteTeammate'

export enum ActionTypeEnum {
  INVITE_TEAMMATE = 'invite-teammate',
  CREATE_CUSTOM_ACCESS_LEVEL = 'create-custom-access-level',
  CREATE_FRANCHISE_GROUP = 'create-franchise-group',
  ADD_NEW_STORE = 'add-new-store',
  GENERATE_CREDENTIALS = 'generate-credentials',
  REPORT_ISSUE = 'report-issue',
  READ_DOCS = 'read-docs',
  CALL_SUPPORT = 'call-support',
  CONFIGURE_STORE_RESTORE_LOCATION = 'configure-store-restore-location',
  CONFIGURE_STORE_RESTORE_REASON_MODE = 'configure-store-restore-reason-mode',
  CONFIGURE_STORE_RESTORE_SLACK_ALERT = 'configure-store-restore-slack-alert',
  CONFIGURE_RECOVER_LOCATION = 'configure-recover-location',
  CONFIGURE_RECOVER_CATEGORY = 'configure-recover-category',
  INTEGRATE_ACCOUNTING_SOFTWARE = 'integrate-accounting-software',
  INTEGRATE_BANK_ACCOUNT = 'integrate-bank-account',
  AUTOMATE_JOURNAL_ENTRIES = 'automate-journal-entries',
  INTEGRATE_MARGINEDGE = 'integrate-marginedge'
}

export enum StepInputType {
  INPUT = 'input',
  SINGLE_SELECT = 'single_select',
  MULTI_SELECT = 'multi_select'
}

export const actionsSubmitFunctions = {
  [ActionTypeEnum.INVITE_TEAMMATE]: {
    submitFn: inviteTeammate
  }
}

export const actionsMapping = {
  [ActionTypeEnum.INVITE_TEAMMATE]: {
    steps: [
      {
        step_id: 'name',
        step_type: StepInputType.INPUT,
        step_title: 'Name',
        step_description: 'Enter the name of the teammate',
        step_required: true
      },
      {
        step_id: 'email',
        step_type: StepInputType.INPUT,
        step_title: 'Email',
        step_description: 'Enter the email of the teammate',
        step_required: true
      },
      {
        step_id: 'access_level',
        step_type: StepInputType.SINGLE_SELECT,
        step_title: 'Access Level',
        step_description: 'Select the access level of the teammate',
        step_required: true,
        step_options: accessLevelStepOptions,
        on_select: (value) => {
          if (value === AccessLevelEnum.BUSINESS_MANAGER) {
            return 'multi_franchise_group'
          } else if (value === AccessLevelEnum.INTERNAL_OPERATOR) {
            return 'single_franchise_group'
          } else if (value === AccessLevelEnum.STORE_MANAGER || value === AccessLevelEnum.OBSERVER || value === AccessLevelEnum.OWNER_VIEW) {
            return 'locations'
          } else if (value === AccessLevelEnum.FINANCE_TEAM || value === AccessLevelEnum.BUSINESS_ADMIN) {
            return 'finish'
          } else {
            return null
          }
        }
      },
      {
        step_id: 'single_franchise_group',
        step_type: StepInputType.SINGLE_SELECT,
        step_title: 'Franchise Group',
        step_description: 'Select the franchise group of the teammate',
        step_key: 'subchains',
        step_required: true,
        step_options: franchiseGroupStepFunction,
        on_select: (value) => {
          return 'finish'
        }
      },
      {
        step_id: 'multi_franchise_group',
        step_type: StepInputType.MULTI_SELECT,
        step_title: 'Franchise Group',
        step_description: 'Select the franchise groups of your teammate',
        step_key: 'subchains',
        step_required: true,
        step_options: franchiseGroupStepFunction,
        on_select: (value) => {
          return 'finish'
        }
      },
      {
        step_id: 'locations',
        step_type: StepInputType.MULTI_SELECT,
        step_title: 'Locations',
        step_description: 'Select the locations of the teammate',
        step_required: true,
        step_options: locationStepFunction,
        on_select: (value) => {
          return 'finish'
        }
      }
    ],
    submitFn: inviteTeammate
  }
}
